import { IWorkspaceTeam } from 'src/@types/workspace-info';
import { axios } from 'src/utils/axios';

export async function getTeams(): Promise<IWorkspaceTeam[]> {
  const { data } = await axios.get(`/team`);
  return data;
}

export async function getTeamById(id: string): Promise<IWorkspaceTeam[]> {
  const { data } = await axios.get(`/team/${id}`);
  return data;
}

export type CreateTeamPayload = {
  name: string;
  picture?: string;
  participants?: string[];
};
export async function createTeam(
  payload: CreateTeamPayload,
): Promise<IWorkspaceTeam> {
  const { data } = await axios.post(`/team/create`, payload);
  return data;
}

type UpdateTeamPayload = {
  id: string;
  name: string;
  picture?: string;
  participants?: string[];
};
export async function updateTeam(
  payload: UpdateTeamPayload,
): Promise<IWorkspaceTeam> {
  const { data } = await axios.put(`/team/update`, payload);
  return data;
}

type EditParticipantPayload = {
  id: string;
  participants?: string[];
};
export async function addParticipants(
  payload: EditParticipantPayload,
): Promise<IWorkspaceTeam> {
  const { data } = await axios.put(`/team/add-participant`, payload);
  return data;
}

export async function removeParticipants(
  payload: EditParticipantPayload,
): Promise<IWorkspaceTeam> {
  const { data } = await axios.put(`/team/remove-participant`, payload);
  return data;
}

export async function deleteTeam(id: string): Promise<IWorkspaceTeam> {
  const { data } = await axios.delete(`/team/delete?id=${id}`);
  return data;
}

export * as TeamRequests from './team.requests';
